<template>
  <div>
    <component :class="[componentData.name.toLowerCase()]" :is="cmpType" :cmpConfig="componentData">
    </component>
  </div>
</template>

<script>
import cwImageWrapper from './cwImageWrapper.vue';
import cwRoundTextBoxWrapper from './cwRoundTextBoxWrapper.vue';

import cwLineWrapper from './cwLineWrapper';

export default {
  name: 'CwGenericDecoration',
  components: { cwImageWrapper, cwRoundTextBoxWrapper, cwLineWrapper },
  props: {
    componentData: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      cactusElements: require('./cactus_elements.json')
    };
  },
  computed: {
    cmpType() {
      if (!this.componentData.type) return;

      let regExp = /([_])([a-zA-Z])/gm;
      let cmp = this.componentData.type;

      let matchGroups = cmp.match(regExp);
      if (matchGroups) {
        matchGroups.forEach(el => {
          cmp = cmp.replace(el, el.toUpperCase().replace('_', ''));
        });
      }

      return `cw${cmp.charAt(0).toUpperCase()}${cmp.substring(1)}Wrapper`;
    }
  },
  methods: {}
};
</script>

<style scoped></style>
